import React from 'react';
import './NotificationToast.css';

const NotificationToast = ({ message }) => {
  if (!message) return null;

  return <div className="notification-toast">{message}</div>;
};

export default NotificationToast;
